export const buildTreatmentData = (data, prevData) => {
  const treatmentData = { ...prevData };

  Object.keys(data).forEach(key => {
    if (treatmentData[key]) {
      treatmentData[key].push(data[key]);
    } else {
      treatmentData[key] = [data[key]];
    }
  });

  return treatmentData;
};

export const deleteTreatmentData = (treatment, data) => {
  const updatedTreatments = { ...data };
  const index = Object.values(updatedTreatments)[0].indexOf(treatment);

  Object.keys(updatedTreatments).forEach(key => {
    updatedTreatments[key].splice(index, 1);
  });

  return updatedTreatments;
};

export const updateTreatmentData = ({ index, data }, prevData) => {
  const updatedTreatments = { ...prevData };
  Object.keys(updatedTreatments).forEach(key => {
    updatedTreatments[key][index] = data[key];
  });
  return updatedTreatments;
};
